module.exports = __webpack_public_path__ + "static/media/Background.a5770198.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/Background/Background.webp
// module id = 427
// module chunks = 4